import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { assetUrl, getStoredUser, getUserToken, isTrue } from "../../functions/themeAssets";
import { Loader } from "../bigpicture/components";
import Leaderboard from "./Leaderboard";
import "../styles/bp-thanks.css";

const post = (path, user, body) =>
  fetch(`${process.env.REACT_APP_BACKEND_URL}/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getUserToken(user)}` },
    body: JSON.stringify(body),
  }).then((r) => r.json());

/** Thank-you page: the finished big picture, the admin's message, the player's score and (optionally) the leaderboard. */
export default function ThankYou() {
  const navigate = useNavigate();
  const { data: themeData } = useSelector((state) => state.theme);
  const [report, setReport] = useState(null);
  const [leaderboard, setLeaderboard] = useState(null);
  const user = getStoredUser();
  const showLeaderboard = isTrue(themeData?.leaderboard_toggle);

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
      return undefined;
    }
    let cancelled = false;
    post("fetchReport", user, { userId: user.userId })
      .then((json) => {
        if (cancelled) return;
        if (json.success && json.report && json.report.gameover) {
          setReport(json.report);
        } else {
          // not finished yet: back to where the player left off
          navigate("/rules", { replace: true });
        }
      })
      .catch(() => !cancelled && navigate("/rules", { replace: true }));
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user || !showLeaderboard) return undefined;
    let cancelled = false;
    post("getGameLeaderboard", user, { userId: user.userId })
      .then((json) => !cancelled && json.success && setLeaderboard(json.data))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showLeaderboard]);

  if (!report || !themeData) return <Loader />;

  const color = themeData.landing_page_title_color || "#000000";
  const thanks = String(themeData.custom_text_thank_you_page || "").trim();
  const rows = leaderboard ? [...leaderboard.top, ...(leaderboard.me ? [leaderboard.me] : [])] : [];

  return (
    <div className="bp-thanks">
      {themeData.puzzle_image && <img src={assetUrl(themeData.puzzle_image)} className="thankyou-logo" alt="" />}

      {thanks && (
        <div className="thankyou-text" style={{ color }}>
          {thanks}
        </div>
      )}

      {showLeaderboard && <Leaderboard leaderboard={leaderboard} rows={rows} user={user} />}

      {!showLeaderboard && (
      <div className="score" style={{ color }}>
        Congratulations on completing the BigPicture with score {report.points} out of {report.total} in {report.time}{" "}
        minutes.
      </div>
      )}
    </div>
  );
}
